<template>
    <div>
        <div class="card shadow">
            <div class="card-header bg-transparent">
                <div>
                    <h3 class="mb-0">
<!--                        {{ $t('message.add') }} {{  $tc('message.commonParameters', 1) }}-->
                        {{ $t('message.add') }} {{ $t('message.parameter') }}
                    </h3>
                </div>
            </div>


            <div class="card-body">
                <b-form @submit="onSubmit" @reset="onReset" v-if="show">
                    <b-container>
                        <b-row>

                            <b-col sm="4">

                                <b-form-group
                                        id="poids-group"
                                        :label="$t('message.weight')"
                                        label-for="poids"
                                >
                                    <b-form-input
                                            id="reference"
                                            v-model="$v.form.poids.$model"
                                            :state="$v.form.poids.$dirty ? !(errorshasField('poids') || $v.form.poids.$error) : null"
                                            required
                                            @focus="clearErrorField('poids')"

                                    ></b-form-input>

                                    <b-form-invalid-feedback v-if="!$v.form.poids.required">
                                        {{ $t('message.requiredField') }}
                                    </b-form-invalid-feedback>

                                    <b-form-invalid-feedback v-else-if="errorshasField('poids')">
                                        {{ getErrorsField('poids') }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>

                            <b-col sm="4">

                                <b-form-group
                                        id="taille-group"
                                        :label="$t('message.height')"
                                        label-for="taille"
                                >
                                    <b-form-input
                                            id="taille"
                                            v-model="$v.form.taille.$model"
                                            :state="$v.form.taille.$dirty ? !(errorshasField('taille') || $v.form.taille.$error) : null"
                                            required
                                            @focus="clearErrorField('taille')"
                                    ></b-form-input>
                                    <b-form-invalid-feedback v-if="!$v.form.taille.required">
                                        {{ $t('message.requiredField') }}
                                    </b-form-invalid-feedback>

                                    <b-form-invalid-feedback v-else-if="errorshasField('taille')">
                                        {{ getErrorsField('taille') }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>

                            <b-col sm="4">

                                <b-form-group
                                        id="temperature-group"
                                        :label="$t('message.temperature')"
                                        label-for="temperature"
                                >
                                    <b-form-input
                                            id="temperature"
                                            v-model="$v.form.temperature.$model"
                                            :state="$v.form.temperature.$dirty ? !(errorshasField('temperature') || $v.form.temperature.$error) : null"
                                            required
                                            @focus="clearErrorField('temperature')"

                                    ></b-form-input>

                                    <b-form-invalid-feedback v-if="!$v.form.temperature.required">
                                        {{ $t('message.requiredField') }}
                                    </b-form-invalid-feedback>

                                    <b-form-invalid-feedback v-else-if="errorshasField('temperature')">
                                        {{ getErrorsField('temperature') }}
                                    </b-form-invalid-feedback>
                                </b-form-group>

                            </b-col>

                        </b-row>


                        <b-row>




                            <b-col sm="4">

                                <b-form-group
                                        id="ta_systolique-group"
                                        :label="$t('message.taSystolique')"
                                        label-for="ta_systolique"
                                >
                                    <b-form-input
                                            id="ta_systolique"
                                            v-model="$v.form.ta_systolique.$model"
                                            :state="$v.form.ta_systolique.$dirty ? !(errorshasField('ta_systolique') || $v.form.ta_systolique.$error) : null"
                                            required
                                            @focus="clearErrorField('ta_systolique')"

                                    ></b-form-input>

                                    <b-form-invalid-feedback v-if="!$v.form.ta_systolique.required">
                                        {{ $t('message.requiredField') }}
                                    </b-form-invalid-feedback>

                                    <b-form-invalid-feedback v-else-if="errorshasField('ta_systolique')">
                                        {{ getErrorsField('ta_systolique') }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>


                            <b-col sm="4">

                                <b-form-group
                                        id="ta_diastolique-group"
                                        :label="$t('message.taDiastolique')"
                                        label-for="ta_diastolique"
                                >
                                    <b-form-input
                                            id="ta_diastolique"
                                            v-model="$v.form.ta_diastolique.$model"
                                            :state="$v.form.ta_diastolique.$dirty ? !(errorshasField('ta_diastolique') || $v.form.ta_diastolique.$error) : null"
                                            required
                                            @focus="clearErrorField('ta_diastolique')"
                                    ></b-form-input>
                                    <b-form-invalid-feedback v-if="!$v.form.ta_diastolique.required">
                                        {{ $t('message.requiredField') }}
                                    </b-form-invalid-feedback>

                                    <b-form-invalid-feedback v-else-if="errorshasField('ta_diastolique')">
                                        {{ getErrorsField('ta_diastolique') }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>

                            <b-col sm="4">

                                <b-form-group
                                        id="frequence_cardiaque-group"
                                        :label="$t('message.heartRate')"
                                        label-for="frequence_cardiaque"
                                >
                                    <b-form-input
                                            id="frequence_cardiaque"
                                            v-model="$v.form.frequence_cardiaque.$model"
                                            :state="$v.form.frequence_cardiaque.$dirty ? !(errorshasField('frequence_cardiaque') || $v.form.frequence_cardiaque.$error) : null"
                                            required
                                            @focus="clearErrorField('frequence_cardiaque')"

                                    ></b-form-input>

                                    <b-form-invalid-feedback v-if="!$v.form.frequence_cardiaque.required">
                                        {{ $t('message.requiredField') }}
                                    </b-form-invalid-feedback>

                                    <b-form-invalid-feedback v-else-if="errorshasField('frequence_cardiaque')">
                                        {{ getErrorsField('frequence_cardiaque') }}
                                    </b-form-invalid-feedback>
                                </b-form-group>

                            </b-col>

                        </b-row>

                        <b-row>

                            <b-col sm="6">

                                <b-form-group
                                        id="frequence_respiratoire-group"
                                        :label="$t('message.respiratoryRate')"
                                        label-for="frequence_respiratoire"
                                >
                                    <b-form-input
                                            id="frequence_respiratoire"
                                            v-model="$v.form.frequence_respiratoire.$model"
                                            :state="$v.form.frequence_respiratoire.$dirty ? !(errorshasField('frequence_respiratoire') || $v.form.frequence_respiratoire.$error) : null"
                                            required
                                            @focus="clearErrorField('frequence_respiratoire')"

                                    ></b-form-input>

                                    <b-form-invalid-feedback v-if="!$v.form.frequence_respiratoire.required">
                                        {{ $t('message.requiredField') }}
                                    </b-form-invalid-feedback>

                                    <b-form-invalid-feedback v-else-if="errorshasField('frequence_respiratoire')">
                                        {{ getErrorsField('frequence_respiratoire') }}
                                    </b-form-invalid-feedback>
                                </b-form-group>

                            </b-col>

                            <b-col sm="6">

                                <b-form-group
                                        id="sato2-group"
                                        :label="$t('message.sato2')"
                                        label-for="sato2"
                                >
                                    <b-form-input
                                            id="sato2"
                                            v-model="$v.form.sato2.$model"
                                            :state="$v.form.sato2.$dirty ? !(errorshasField('sato2') || $v.form.sato2.$error) : null"
                                            required
                                            @focus="clearErrorField('sato2')"
                                    ></b-form-input>
                                    <b-form-invalid-feedback v-if="!$v.form.sato2.required">
                                        {{ $t('message.requiredField') }}
                                    </b-form-invalid-feedback>

                                    <b-form-invalid-feedback v-else-if="errorshasField('sato2')">
                                        {{ getErrorsField('sato2') }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>

                        </b-row>

                        <b-row class="justify-content-sm-center" v-if="can">
                            <b-button type="submit" variant="primary">
                                {{ $t('message.save') }}
                            </b-button>

                            <!--                            <b-button type="reset" variant="danger">-->
                            <!--                                {{ $t('message.reset') }}-->
                            <!--                            </b-button>-->
                        </b-row>
                    </b-container>
                </b-form>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import { required } from 'vuelidate/lib/validators';
    import _ from 'lodash';
    import SlimSelect from 'slim-select';

    export default {
        name: "AddCommon",

        computed: {
            ...mapGetters(["generalConsultation", "errors","hasAdminRole", "hasMedecinControleRole", "hasPraticienRole","hasAssistante"]),

            can: function (){
                if (this.hasAdminRole){
                    return true;
                }else{
                    return this.hasMedecinControleRole || this.hasPraticienRole || this.hasAssistante;
                }
            },

            mConsultation: function() {
                let consultation = this.generalConsultation;
                if(typeof consultation.user == 'object'){
                    let user = consultation.user;

                    let nom = user.nom + ((user.prenom != null && user.prenom) ? (' ' + user.prenom) : '');
                    let dossier = consultation.dossier.numero_dossier;

                    let text = nom + ' ( ' + dossier + ' )'+ " " +consultation.date_consultation;
                    return text;
                }
                return  "";
            }
        },

        data() {
            return {
                consultation_id: this.$route.params.consultation,
                form: {
                    // consultation: null,
                    poids: '',
                    taille: '',
                    ta_systolique: '',
                    ta_diastolique: '',
                    temperature: '',
                    frequence_cardiaque: '',
                    frequence_respiratoire: '',
                    sato2: '',
                },
                show: true
            }
        },

        methods: {
            getConsultations: function() {
                let args = {
                    consultation: this.consultation_id
                };

                this.$store.dispatch("getGeneralConsultation", { args });
            },

            onSubmit: function(evt) {
                evt.preventDefault();

                this.$v.$touch();

                if(!this.$v.$invalid) {
                    let args = {
                        consultation_medecine_generale_id: this.generalConsultation.id,
                        poids: this.form.poids,
                        taille: this.form.taille,
                        ta_systolique: this.form.ta_systolique,
                        ta_diastolique: this.form.ta_diastolique,
                        temperature: this.form.temperature,
                        frequence_cardiaque: this.form.frequence_cardiaque,
                        frequence_respiratoire: this.form.frequence_respiratoire,
                        sato2: this.form.sato2,
                    };

                    let successMessage = this.$i18n.t('message.commonParameterCreated');
                    let errorMessages = {
                        generic: this.$i18n.t('message.genericError'),
                        error: this.$i18n.t('message.genericError') // TODO: Prendre message approprié
                    };

                    this.$store.dispatch('createCommonParameter', { args, errorMessages, successMessage })
                        .then(() => {
                            // Scroll to the top of the page
                            document.body.scrollTop = 0; // For Safari
                            document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
                        });
                }
            },

            onReset: function(evt) {
                evt.preventDefault();

                // Reset our form values
                // this.form.consultation = '';
                // this.form.poids = '';
                // this.form.taille = '';

                // Trick to reset/clear native browser form validation state
                this.show = false;

                this.$nextTick(() => {
                    this.show = true;
                });
            },

            getErrorsField(field){
                if (this.errorshasField(field)){
                    return this.errors[field][0];
                }else{
                    return  '';
                }
            },

            errorshasField(field){
                return this.errors.hasOwnProperty(field);
            },

            clearErrorField(field){
                this.$store.dispatch('clearErrorField', { field });
                this.getErrorsField(field);
            }
        },

        validations: {
            form: {
                // consultation: {
                //     required
                // },
                poids: {

                },
                taille: {

                },
                ta_systolique: {

                },
                ta_diastolique: {

                },
                temperature: {

                },
                frequence_cardiaque: {
                },

                frequence_respiratoire: {
                },
                sato2: {
                },
            }
        },

        mounted() {
            // Retrieve general consultation list
            this.getConsultations();

            // new SlimSelect({
            //     select: '#single',
            //     placeholder: 'Select a file number or user information',
            //     showSearch: false,
            //
            // })
        }
    }
</script>

<style scoped>
    @import url('~slim-select/dist/slimselect.min.css');
</style>